import type { QueryClient } from '@tanstack/react-query';

import resolvePresetBySlug from '@/requests/library/resolvePresetBySlug';
import { setAppStore } from '@/store';
import buildInputsFromPreset from '@/utils/preset/buildInputsFromPreset';
import { Screen } from '@/types';

import type { Preset } from '@/types';

/**
 * Single write path for "open this preset". Throws on an unresolvable slug —
 * callers own the failure UX.
 */
const selectPresetBySlug = async (
  slug: string,
  queryClient: QueryClient
): Promise<Preset> => {
  const preset = await resolvePresetBySlug(slug, queryClient);

  setAppStore({
    selectedPreset: { ...preset, slug },
    inputs: buildInputsFromPreset(preset),
    screen: Screen.Create,
    isPresetLoading: false,
  });

  return preset;
};

export default selectPresetBySlug;
